var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.columnData[_vm.columnDefinition.route])?_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.linkClicked}},[_vm._v(" "+_vm._s(_vm.$t(_vm.columnDefinition.label))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }